import React from 'react';
import { intlShape, injectIntl } from 'react-intl';
import randomstring from 'uuid/v4';
import md5 from 'md5';
import FilterMenu from './FilterMenu';

import CloseIcon from '@material-ui/icons/Cancel';

import { ProcessIcon, FilterIcon } from '../../../../images/icons/WrapSvg';
import { types } from '../../../../const/types.task';

const flatObject = (fields, filledText) => {
    return fields.reduce((arr, f) => {
        if (f.campos) {
            arr = arr.concat(flatObject(f.campos, filledText));
        } else {
            if( 
                f.tipo === types.datetime
            ) {
                f.valor = f.valor ? f.valor.replace('T', ' ') : undefined;
                arr.push(f);
            } else if( 
                f.tipo === types.boolean
                || f.tipo === types.text
                || f.tipo === types.real
                || f.tipo === types.date
                || f.tipo === types.datetime
                || f.tipo === types.time
                || f.tipo === types.auto
                || f.tipo === types.temp
            ) {
                arr.push(f);
            }else {
                console.log(f);
                f.valor = f.valor ? filledText : undefined;
                arr.push(f);
            }
        }
        return arr;
    }, [])
}


function toolbar(handleFilter, nofiltered) {
    const aux = [];
    aux.push(
        <FilterIcon
            disabled
            key={'hide-menu-toolbar'}
            color={nofiltered ? 'primary' : 'secondary'}
            onClick={handleFilter}
        />,
    );
    return aux;
}

class ListValues extends React.Component {

    state = {
        error: undefined,
        report_employee: undefined,
        message: undefined,
        hide: [],
        shownlocals: [],
        select: undefined
    }

    componentDidMount() {
        const tools = [toolbar(this.handleFilter, true)];
        this.props.setTools(tools);
    }

    componentWillUnmount() {
        this.props.setTools([]);
    }

    static getDerivedStateFromProps(props, state) {
        const { report_employee, proceso, intl } = props;
        if (report_employee !== state.report_employee) {
            state.report_employee = report_employee;
            const temp = report_employee
                ? report_employee.familias.reduce((arr, f) => {
                    arr = arr.concat(f.procesos.reduce((arr, p) => {
                        arr = arr.concat(
                            p.instancias && p.instancias.length > 0    
                            ? p.instancias.reduce((arr, i) => {
                                            arr.push({
                                                nlocal: i.nlocal,
                                                local: i.local
                                            })
                                            return arr;
                                        }, [])
                            : []
                            )
                        return arr;
                    }, []))
                    return arr;
                }, [])
                : [];
            state.shownlocals = temp.reduce((arr, l) => {
                if (arr.map((l) => l.local).indexOf(l.local) < 0) {
                    arr.push(l);
                }
                return arr;
            }, []);
            state.instances = report_employee
                                    .familias
                                    .reduce((arr, f) => {
                                        arr = arr.concat(
                                            f.procesos.reduce((arr, p) => {
                                                if (p.codigo.toUpperCase() === proceso.toUpperCase()) {
                                                    arr = arr.concat(
                                                        p.instancias.map((i) => {
                                                            return {
                                                                    family: f.nombre,
                                                                    nprocess: p.nombre,
                                                                    codigo: p.codigo,
                                                                    id: i.id,
                                                                    nlocal: i.nlocal,
                                                                    local: i.local,
                                                                    fecha: i.fecha,
                                                                    tipo: i.tipo,
                                                                    ntrabajador: i.ntrabajador,
                                                                    values: flatObject(i.campos, intl.formatMessage({ id: 'report_employee_filled' }))
                                                                };
                                                        })
                                                    );
                                                }
                                                return arr;
                                            }, [])
                                        )
                                        return arr;
                                    }, []);
            state.nproceso = state.instances && state.instances.length > 0 ? state.instances[0].nprocess : '';
            state.columns = state.instances && state.instances.length > 0 ? state.instances[0].values.map((c) =>{ return { codigo: c.codigo, nombre: c.nombre } }) : '';
            return state;
        }
        return null;
    }

    handleFilter = (event) => {
        this.setState({ open: true });
    }

    handleCloseFilter = (hide) => {
        this.setState({ open: false, hide: hide });
        const tools = [toolbar(this.handleFilter, hide && hide.length === 0)];
        console.log(hide);
        this.props.setTools(tools);
    }

    handleScroll = (e) => {
        this.props.setProminentToolBar(e.currentTarget.scrollTop === 0);
    }

    handleDetail = (id) => {
        this.props.history.push(`/reports/employee/detail/${id}`)
    }

    timer = () => {
        clearInterval(this.state.intervalId);
        this.setState({ message: undefined });
    }

    handleTooltipOpen = (family, proceso, i, field) => (event) => {
        console.log(family, proceso, i, field);
        const message =
            <div className="flex_full_row popup bg_golden_yellow c_white padding_borders border_radius_6 center">
                <div className="flex_auto_row center ">
                    <CloseIcon className="hand margin_right_12" onClick={this.handleTooltipClose} />
                </div>
                <div className="flex_full_column">
                    {i.fecha &&
                        <div className="flex_full_row nowrap barlow_regular_smalltext margin_top_4 margin_left_2">
                            {this.props.intl.formatMessage({ id: 'visibility_init' })}
                            {': '}
                            {i.fecha}
                        </div>
                    }
                    {i.ntrabajador &&
                        <div className="flex_full_row nowrap barlow_regular_smalltext margin_top_4 margin_left_2">
                            {this.props.intl.formatMessage({ id: 'user' })}
                            {': '}
                            {i.ntrabajador}
                        </div>
                    }
                    {field.comentario &&
                        <div className="flex_full_row nowrap barlow_regular_smalltext margin_top_4 margin_left_2">
                            {this.props.intl.formatMessage({ id: 'type_label_comment' })}
                            {': '}
                            {field.comentario}
                        </div>
                    }
                </div>
                <div className="flex_auto_row center margin_left_12">
                    <ProcessIcon className="hand" onClick={(event) => this.props.history.push(`/processes/${md5(family)}/${proceso}/${i.id}`)} />
                </div>
            </div>

        const intervalId = setInterval(this.timer, 10000);
        this.setState({ intervalId: intervalId, message: message, selected: i.id });
    }

    handleTooltipClose = (event) => {
        this.setState({ message: undefined });
    }

    render() {
        const { intl, report_employee } = this.props;
        const { message, shownlocals, hide, open, instances, nproceso, columns, selected } = this.state;
        console.log(report_employee);
        if (nproceso) {
            return (
                <div className="flex_full_column">
                    <div
                        onScroll={this.handleScroll}
                        className="flex_full_column overflow_y_scroll showbar padding_borders">
                        <div className="flex_auto_row padding_borders_flat bg_grey_blue c_white uppercase center margin_bottom_12">
                            <span className="">{report_employee.nombreTrabajador}</span>
                        </div>
                        <div className="flex_auto_row padding_borders_flat bg_cloudy_blue c_slate uppercase center margin_bottom_12">
                            <span className="">{report_employee.desde.split(" ")[0]}</span>
                            <span className="margin_left_12 margin_right_12">{"-"}</span>
                            <span className="">{report_employee.hasta.split(" ")[0]}</span>
                        </div>
                        <div className="flex_auto_column margin_bottom_48">
                            <div
                                key={randomstring()}
                                className="flex_auto_column margin_bottom_12">
                                <div className="flex_auto_row padding_borders_flat bg_light-purple c_slate uppercase center margin_bottom_12">
                                    <span className="flex_full_row">{nproceso}</span>
                                </div>
                                {
                                    columns.map((c) => {
                                        return<div
                                                key={randomstring()}
                                                className="flex_auto_column margin_bottom_12">
                                                <div className="flex_auto_row padding_borders_flat bg_light_purple_40 c_slate uppercase center margin_bottom_12">
                                                    <span className="flex_full_row">{c.nombre}</span>
                                                </div>
                                                <div className="flex_auto_row wrap">
                                                {
                                                    instances
                                                        .sort((a, b) => a.id > b.id ?  1 : -1)
                                                        .map((i) => {
                                                            const field = i.values.find((f) => f.codigo === c.codigo);
                                                            if(field && hide.indexOf(i.local) < 0 ){
                                                                console.log(field);
                                                                return( 
                                                                    <div
                                                                        key={randomstring()}
                                                                        className={ 
                                                                                    "boxBorder flex_auto_column hand center padding_borders resumen_height_50 margin_right_12 margin_bottom_12  " 
                                                                                    + ((field.valor !== null && field.valor !== undefined)
                                                                                            ? (field.alerta ? 'bg_lipstickligth ' : 'bg_pealigth ') 
                                                                                            : 'bg_white ')
                                                                                    + (i.id === selected ? 'border_selected' : '')
                                                                                }
                                                                        onClick={this.handleTooltipOpen(i.family, i.codigo, i, field)}
                                                                    >
                                                                        <span className="flex_auto_row c_cool_grey_two margin_bottom_5">

                                                                            {field.valor === true
                                                                                ? intl.formatMessage({ id: 'type_label_boolean_yes' })
                                                                                : field.valor === false
                                                                                    ? intl.formatMessage({ id: 'type_label_boolean_no' })
                                                                                    : field.valor
                                                                            }
                                                                        </span>
                                                                    </div>
                                                                )
                                                            }
                                                            return <div key={randomstring()} />
                                                        })
                                                }
                                                </div>
                                            </div>
                                    })
                                }
                            </div>
                        </div>
                    </div>
                    {message}
                    {open &&
                        <FilterMenu {...this.props} shownlocals={shownlocals} hide={hide} onClose={this.handleCloseFilter} />
                    }
                </div>
            )
        } else {
            return <div />;
        }
    }
}

ListValues.propTypes = {
    intl: intlShape.isRequired,
};

export default injectIntl(ListValues);



// WEBPACK FOOTER //
// ./src/components/complex/reports/employee/Detail.js